/**
 * christmasTreeIconSingleton.js
 * Created by Destin Frasier on 08/15/19.
 */

import { IconSingleton } from '../iconSingleton';

class ChristmasTreeIconSingleton extends IconSingleton {
    constructor() {
        super();

        this.notificationName = 'icons-christmas-tree.loaded';
        this.svgPath = `${process.env.CDN}/graphics/christmasTreeIcons.svg`;
    }
}

const instance = new ChristmasTreeIconSingleton();
export default instance;
